import { DynamicIcon } from 'phosphor-icons/react';
import { c } from '../../utils/tailwind-merge';
import { VerifiedSolution } from '../VerifiedSolution/VerifiedSolution';
import type { BadgeProps } from './types';

const badgeStyle =
  'py-0.5 px-1.5 rounded-sm bg-grey-100 font-normal tracking-tighter text-grey-700 text-xs';

const styleClasses = {
  base: 'flex items-center space-x-1 justify-center',
  badgeWithIcon: badgeStyle,
  badge: badgeStyle,
};

export const Badge = ({
  text,
  iconName,
  appearance,
  className = '',
  testId = '',
}: BadgeProps) => {
  return (
    <div data-test={testId}>
      <div
        className={c(styleClasses.base, styleClasses[appearance], className)}
      >
        <span>{text}</span>
        {iconName === 'HexagonWithCheck' ? (
          <VerifiedSolution
            microcopy={{
              title:
                '<b>Verified Solution</b> are thoroughly verified by Unity and offer:',
              benefit1: 'Compatibility with the latest Unity releases',
              benefit2: 'Long-term dependability',
              benefit3: 'Scalable and custom solutions',
              cta: 'Learn more about Verified Solutions',
            }}
            link="#"
            className="flex align-middle"
          />
        ) : (
          iconName && (
            <DynamicIcon
              aria-hidden="true"
              iconName={iconName}
              className={c(
                'h-[14px] w-[14px] lg:h-[16px] lg:w-[16px]',
                appearance === 'badgeWithIcon' ? 'ml-1' : 'ml-2'
              )}
            />
          )
        )}
      </div>
    </div>
  );
};
